import { render, staticRenderFns } from "./article-slider.vue?vue&type=template&id=74936c72"
import script from "./article-slider.vue?vue&type=script&lang=js"
export * from "./article-slider.vue?vue&type=script&lang=js"
import style0 from "./article-slider.vue?vue&type=style&index=0&id=74936c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports